module.exports = __webpack_public_path__ + "static/img/title@2x.6d72e9b4.png";